import React, { useState } from "react";
import { X } from "lucide-react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAppContext } from "../context/AppContext";
import { Reminder } from "../utils/helpers";

export default function ReminderForm({
  setShowForm,
  activePetId,
}: {
  setShowForm: (v: boolean) => void;
  activePetId: string;
}) {
  const { t, user } = useAppContext();
  const [recType, setRecType] = useState("none");

  const handleAddReminder = async (e: any) => {
    e.preventDefault();
    if (!user) return;
    const fd = new FormData(e.currentTarget);
    const rec = fd.get("recurrence") as string;
    const r: Reminder = {
      id: Date.now(),
      petId: activePetId || "",
      userId: user.uid,
      title: fd.get("title") as string,
      type: fd.get("type") as string,
      date: fd.get("date") as string,
      time: fd.get("time") as string,
      recurrence: rec === "custom" ? `custom_${fd.get("customDays")}` : rec,
      notify: fd.get("notify") as string,
      completed: false,
    };
    await setDoc(doc(db, "users", user.uid, "reminders", r.id.toString()), r);
    setShowForm(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[200] flex flex-col justify-end backdrop-blur-sm animate-fade-in">
      <div className="bg-[var(--bg-card)] rounded-t-[2.5rem] p-6 pb-12 border-t border-[var(--border-color)]">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-extrabold text-xl text-[var(--text-main)]">
            {t.modNewRem}
          </h3>
          <button
            onClick={() => setShowForm(false)}
            className="text-[var(--text-main)]"
          >
            <X size={20} />
          </button>
        </div>
        <form onSubmit={handleAddReminder} className="flex flex-col gap-4">
          <div>
            <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
              {t.modTitle}
            </label>
            <input
              name="title"
              required
              className="w-full h-12 px-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none text-sm"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
              {t.modType}
            </label>
            <select
              name="type"
              className="w-full h-12 px-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none text-sm"
            >
              <option>{t.modVac}</option>
              <option>{t.modPills}</option>
              <option>{t.modCheckup}</option>
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
                {t.modDate}
              </label>
              <input
                name="date"
                type="date"
                required
                className="w-full h-12 px-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none text-sm"
              />
            </div>
            <div>
              <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
                {t.modTime}
              </label>
              <input
                name="time"
                type="time"
                className="w-full h-12 px-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none text-sm"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-bold text-[var(--text-muted)] mb-2 block">
                {t.modRec}
              </label>
              <select
                name="recurrence"
                value={recType}
                onChange={(e) => setRecType(e.target.value)}
                className="w-full h-12 px-3 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl text-sm"
              >
                <option value="none">{t.modOnce}</option>
                <option value="monthly">{t.modMonth}</option>
                <option value="6months">{t.mod6m}</option>
                <option value="yearly">{t.modYear}</option>
                <option value="custom">{t.modCustom}</option>
              </select>
              {recType === "custom" && (
                <input
                  name="customDays"
                  type="number"
                  required
                  min="1"
                  className="w-full h-12 px-4 mt-2 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none text-sm"
                />
              )}
            </div>
            <div>
              <label className="text-xs font-bold text-[var(--text-muted)] mb-2 block">
                {t.modNotify}
              </label>
              <select
                name="notify"
                className="w-full h-12 px-3 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl text-sm"
              >
                <option value="true">{t.modOn}</option>
                <option value="false">{t.modOff}</option>
              </select>
            </div>
          </div>
          <button
            type="submit"
            className="w-full h-14 bg-[#a073e7] text-white font-bold rounded-xl mt-4 shadow-lg text-sm"
          >
            {t.save}
          </button>
        </form>
      </div>
    </div>
  );
}
